<template>
    <card>
        <card-header>
            <card-title>
                <translate>aktive Angebote</translate>
            </card-title>
        </card-header>
        <card-content>
            <table class="table table--stripped table--td-top table--lot">
                <thead>
                <tr>
                    <th>
                        <translate>PF-Nr</translate>
                    </th>
                    <th>
                        <translate>Projekttitel</translate>
                    </th>
                    <th class="text-center">
                        <translate>Zeichnung</translate>
                    </th>
                    <th class="text-right">
                        <translate>Stück</translate>
                    </th>
                    <th class="text-right">
                        <translate>Stückpreis</translate>
                    </th>
                    <th class="text-right">
                        <translate>Nettopreis</translate>
                    </th>
                    <th class="text-right">
                        <translate>Lieferzeit</translate>
                    </th>
                    <th class="text-right">
                        <translate>gültig bis</translate>
                    </th>
                    <th class="text-center">
                        <translate>Warenkorb</translate>
                    </th>
                    <th class="text-right">
                        <translate>Angebote<span>alternative</span></translate>
                    </th>
                    <th class="text-center">
                        <translate>ablehnen<span>endgültig</span></translate>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="offer in activeOffersTable" :key="offer.index">
                    <td>
                        <Link :href="this.$$route('component', {'askForQuote':offer.id})">{{ offer.pfnumber }}</Link>
                    </td>
                    <td>{{ offer.project_name }}</td>
                    <td class="text-center">
                        <file-download :sketch-file="offer.client_sketch_file" v-if="offer.client_sketch_file"/>
                        <file-download :cad-file="offer.client_cad_file" v-if="offer.client_cad_file"/>
                    </td>
                    <td class="text-right lot-cell" v-html="offer.lot_qty"></td>
                    <td class="text-right lot-cell" v-html="offer.price_per_unit"></td>
                    <td class="text-right lot-cell" v-html="offer.net_price"></td>
                    <td class="text-right lot-cell" v-html="offer.lot_delivery_days"></td>
                    <td class="text-right">{{ offer.offer_valid_date }}</td>

                    <td class="text-center lot-cell">
                        <form-link v-for="addOffer in offer.add_offers" :key="addOffer" :href="this.$$route('checkout.add-offer', {'clientOffer': addOffer})" class="add-to-cart" icon="shopping-cart"
                                   dense="true" color="secondary" :disabled="isInCart(addOffer)" />
                    </td>
                    <td class="text-right">
                        {{ offer.bid_round_member_offers_count_string }}
                    </td>
                    <td class="text-center">
                        <form-button type="button" dense="true" color="error" icon="delete-disabled" @click="rejectOffer(offer)" />
                    </td>
                </tr>
                <tr v-if="noOffers">
                    <td colspan="11" class="text-center">
                        <strong>
                            <translate>keine Einträge vorhanden</translate>
                        </strong>
                    </td>
                </tr>
                </tbody>
            </table>
            <component-offer-reject-modal :ask-for-quote="rejectAskForQuote" v-if="rejectDialog"
                                    @closeDialog="rejectDialog = false" />
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardContent from '@partfactory/Shared/Card/CardContent';
import CardTitle from '@partfactory/Shared/Card/CardTitle';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FileDownload from '@partfactory/Shared/Elements/FileDownload';
import FormLink from '@partfactory/Shared/Form/FormLink';
import ComponentOfferRejectModal from '@partfactory/Pages/Client/Component/ComponentOfferRejectModal';

export default {
    name: 'DashboardActiveOffers',
    components: {ComponentOfferRejectModal, FormLink, FileDownload, FormButton, CardHeader, CardTitle, CardContent, Card},
    props: {
        activeOffers: Object,
    },
    data() {
        let  rejectDialog = false, rejectAskForQuote = null;
        return {rejectDialog, rejectAskForQuote};
    },
    computed: {
        noOffers() {
            return this.activeOffers.length === 0;
        },
        activeOffersTable() {
            let offer = Array;
            return Object.keys(this.activeOffers).map(key => {
                offer[key] = this.activeOffers[key];

                let lotQty = [], pricePerUnit = [], netPrice = [], lotDeliveryDays = [], addOffers = [], offerValidDate = '';

                offer[key].client_offers.map((offer) => {
                    lotQty.push(offer.amount);
                    pricePerUnit.push(offer.net_price / offer.amount);
                    netPrice.push(offer.net_price);
                    lotDeliveryDays.push(offer.delivery_days_client);
                    addOffers.push(offer.id);
                    offerValidDate = this.$date(offer.offer_valid_date);
                });

                offer[key].lot_qty = lotQty.join('<br>');

                offer[key].price_per_unit = pricePerUnit.map(lot => {
                    return lot ? this.$currency(lot) : '';
                }).join('<br>');

                offer[key].net_price = netPrice.map(lot => {
                    return lot ? this.$currency(lot) : '';
                }).join('<br>');

                offer[key].lot_delivery_days = lotDeliveryDays.map((lot) => {
                    return lot + ' '+this.$gettext('Tage');
                }).join(' <br>');

                offer[key].bid_round_member_offers_count_string = offer[key].bid_round_member_offers_count - 1;

                offer[key].add_offers = addOffers;

                offer[key].offer_valid_date = offerValidDate;

                return offer[key];
            });
        },
    },
    methods: {
        rejectOffer(askForQuote) {
            this.rejectAskForQuote = askForQuote;
            this.rejectDialog = true;
        },
        isInCart(offerId) {
                const isInCart = this.$page.props?.cart?.filter((offer) => {
                return offer.id === offerId;
            });
            return isInCart?.length === 0 || isInCart === undefined ? null : 'disabled';
        },
    },
};
</script>
